/**
 * 라벨/옵션 옆에 붙여 사용하는 ? 아이콘 — 호버 또는 클릭 시 안내 표시
 *
 * 사용 예:
 *   <label>
 *     보컬 트랙 <AppHelpIcon>가사가 있는 곡을 만들 때 사용합니다.</AppHelpIcon>
 *   </label>
 */

'use client';

import type { ReactNode } from 'react';
import { HelpCircle } from 'lucide-react';

import { AppTooltip, type AppTooltipTrigger } from './AppTooltip';

export interface AppHelpIconProps {
  /** 안내 본문 — 한국어 여러 줄 가능 */
  children: ReactNode;
  /** 아이콘 크기 (px, 기본 14) */
  size?: number;
  /** 툴팁 위치 */
  position?: 'top' | 'bottom' | 'left' | 'right';
  /** 트리거 — 모바일/터치 환경 대응 시 'click' 권장 */
  triggerOn?: AppTooltipTrigger;
  /** 추가 클래스 */
  className?: string;
  /** 접근성 라벨 (기본: "도움말") */
  ariaLabel?: string;
}

export function AppHelpIcon({
  children,
  size = 14,
  position = 'top',
  triggerOn = 'hover',
  className = '',
  ariaLabel = '도움말',
}: AppHelpIconProps) {
  return (
    <AppTooltip content={children} position={position} triggerOn={triggerOn} className={className}>
      <button
        type="button"
        aria-label={ariaLabel}
        className="inline-flex items-center justify-center text-neutral-400 hover:text-neutral-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-500 focus-visible:ring-offset-1 rounded-full transition-colors"
      >
        <HelpCircle width={size} height={size} aria-hidden="true" />
      </button>
    </AppTooltip>
  );
}

export default AppHelpIcon;
